var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundContactMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 811,
    height: 1684,
    viewBox: "0 0 811 1684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2288_74",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 811,
    height: 1684
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H811V1684H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2288_74)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2288_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.992 228.069C798.283 253.084 1069.43 493.716 1039.61 765.535C1009.8 1037.35 690.31 1237.43 326.02 1212.41C-38.2703 1187.4 -309.416 946.765 -279.6 674.946C-249.784 403.127 69.7021 203.053 433.992 228.069Z",
    fill: "#BD3AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.992 228.069C798.283 253.084 1069.43 493.716 1039.61 765.535C1009.8 1037.35 690.31 1237.43 326.02 1212.41C-38.2703 1187.4 -309.416 946.765 -279.6 674.946C-249.784 403.127 69.7021 203.053 433.992 228.069Z",
    fill: "#D278FF",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2288_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.861 -30.9876C297.775 56.0517 351.789 265.698 285.503 437.271C219.217 608.844 57.7325 677.372 -75.1823 590.333C-208.097 503.294 -262.11 293.647 -195.824 122.074C-129.538 -49.4988 31.9458 -118.027 164.861 -30.9876Z",
    fill: "#FF009C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2288_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1055.1 1047.65C1005.89 1214.03 828.396 1195.41 658.661 1006.06C488.926 816.703 391.224 528.316 440.438 361.928C489.651 195.54 667.144 214.16 836.879 403.516C1006.61 592.872 1104.32 881.259 1055.1 1047.65Z",
    fill: "#C7A3FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2288_74",
    x: -881.842,
    y: -374.047,
    width: 2523.7,
    height: 2188.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_2288_74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2288_74",
    x: -1224.15,
    y: -1068.75,
    width: 2537.98,
    height: 2696.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 500,
    result: "effect1_foregroundBlur_2288_74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2288_74",
    x: -772.303,
    y: -951.633,
    width: 3040.15,
    height: 3312.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 600,
    result: "effect1_foregroundBlur_2288_74"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundContactMobile);
export default __webpack_public_path__ + "static/media/background-contact-mobile.8e309c2148316d48e737f3fdbc927c66.svg";
export { ForwardRef as ReactComponent };